export const MessageType = Object.freeze({
  'fail': 1,
  'frame_recommit': 2,
  'task_recommit': 3,
  'overtake_RAM': 4,
  'Error_Time': 5,
})

export const HaveReadType = Object.freeze({
  No: 0,
  Yes: 1,
})

export const EnableType = Object.freeze({
  No: 0,
  Yes: 1,
})

export const PaneType = Object.freeze({
  SiteMessage: 'site_message',
  MessageControl: 'message_control',
})
